export default __webpack_public_path__ + "static/media/get-a-pic-button-welcome.e00fe930.png";